<template>
    <b-overlay :show="getting">
        <b-card no-body>
            <div class="pt-1 px-1">
                <div class="row">
                    <div class="col-md-2 mb-1 mb-md-0">
                        <input type="number" class="form-control" v-model="birimYolUcreti" placeholder="Birim Yol Ücreti"/>
                    </div>
                    <div class="col-md-1 mb-1 mb-md-0">
                        <input type="number" class="form-control" v-model="sabitOran" placeholder="Sabit Oran"/>
                    </div>
                    <div class="col-md-2 mb-1 mb-md-0">
                        <input type="number" class="form-control" v-model="netCalisma" placeholder="Net Çalışma Gün Sayısı"/>
                    </div>
                    <div class="col-md-auto mb-1 mb-md-0">
                        <button class="btn btn-success" v-on:click="getData">Hesapla</button>
                    </div>
                    <div class="col-md-3 ml-auto">
                        <b-input-group class="input-group-merge">
                            <template #prepend>
                                <b-input-group-text >
                                    <feather-icon icon="SearchIcon"></feather-icon>
                                </b-input-group-text>
                            </template>
                            <b-form-input placeholder="Ara..." v-model="search"></b-form-input>
                        </b-input-group>
                    </div>
                </div>
            </div>
            <div class="px-1 pt-1">
                <img style="max-width: 1600px;" src="@/assets/images/road-equation.svg"/>
            </div>
            <div class="table-responsive">
                <table class="table table-sm bordered-header mt-1">
                    <thead>
                        <tr>
                            <th>Bölge</th>
                            <th>İl</th>
                            <th class="text-right">Endeks</th>
                            <th class="text-right">Katsayı</th>
                            <th class="text-right">Logaritmik Katsayı</th>
                            <th class="text-right">Teorik Mesafe</th>
                            <th class="text-right">Teorik Yol Ücreti</th>
                            <th class="text-right">Teorik Aylık Yol Ücreti</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(d,i) in searched" :style="{backgroundColor:getColor(i)}">
                            <td class="text-nowrap">{{ $safe(d,'RegionName') }}</td>
                            <td>{{ $safe(d,'ProvinceName') }}</td>
                            <td class="text-right">{{ $safe(d,'IndexStr') }}</td>
                            <td class="text-right font-weight-bolder" :style="{color:getColor(i,1)}">{{ $safe(d,'MultiplierStr') }}</td>
                            <td class="text-right">{{ $safe(d,'LogaritmicMultiplierStr') }}</td>
                            <td class="text-right">{{ $safe(d,'TheoreticalRoadDistance') }}</td>
                            <td class="text-right">{{ $safe(d,'TheoreticalRoadPriceStr') }}</td>
                            <td class="text-right">{{ $safe(d,'TheoreticalMonthlyRoadPriceStr') }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </b-card>
    </b-overlay>
</template>

<script>
import { BOverlay, BCard, BInputGroupText, BInputGroup, BFormInput } from 'bootstrap-vue';
import HumanResourcesParameterApi from '@/api/human-resources-parameters';
import additional from '@/utilities/additional'

export default {
    components:{
        BCard,
        BOverlay,
        BInputGroupText,
        BInputGroup,
        BFormInput
    },
    data(){
        return {
            getting:false,
            datas:{},
            search:'',
            birimYolUcreti:null,
            sabitOran:null,
            netCalisma:null,
        }
    },
    mounted(){
        this.getData()
    },
    methods:{
        getData(){
            this.getting = true
            HumanResourcesParameterApi.RoadPricesBasedByOrganisationalLocation({
                BirimYolUcreti: this.birimYolUcreti || null,
                SabitOran: this.sabitOran | null,
                NetCalismaGunSayisi: this.netCalisma | null
            }).then(res => {
                this.datas = res.data.Data || {}
                this.getting = false
            }).catch(err => {
                this.$result(null,err)
                this.getting = false
            })
        },
        getColor(index,alpha = 0.15) {
            const startCol = "#FF2442";  // kırmızı
            const endCol   = "#36AE7C";  // yeşil

            // Hex → {r,g,b}
            function hexToRgb(hex) {
                const h = hex.replace(/^#/, "");
                const num = parseInt(h, 16);
                return {
                r: (num >> 16) & 0xff,
                g: (num >> 8) & 0xff,
                b: num & 0xff
                };
            }

            const start = hexToRgb(startCol);
            const end   = hexToRgb(endCol);

            let ratio = index / ((this.$safe(this.datas,'Provinces') || []).length || 1);
            if (ratio < 0) ratio = 0;
            if (ratio > 1) ratio = 1;

            const r = Math.round(start.r + (end.r - start.r) * ratio);
            const g = Math.round(start.g + (end.g - start.g) * ratio);
            const b = Math.round(start.b + (end.b - start.b) * ratio);

            return `rgba(${r}, ${g}, ${b}, ${alpha})`;
        }
    },
    computed:{
        searched(){
            return (this.$safe(this.datas,'Provinces') || []).filter(s => additional.ToEng(s.ProvinceName.toLowerCase()).includes(additional.ToEng(this.search.toLowerCase())))
        },
    }
}
</script>